import React, { useContext, useState } from 'react'
import { M_Table, LoadingContext, BufferService, NavigateContext } from 'src/components/M_Components'
import { useTranslation } from 'react-i18next'

export const Generator = ({ roles }) => {
    const [refresh, setRefresh] = useState(false)
    const bufferServiceGenerator = new BufferService('Generator')
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()

    const NewRoute = (url, label, operation, data) => {
        ctx.passValue.set('operation', operation)
        if (operation === 'create') {
            ctx2.newTab('createGenerator', t("CreateGenerator"))
            return
        }

        let tempData = data
        if (tempData === 'undefined' || tempData === null || tempData === undefined || tempData === 'null' || tempData.length === 0) {
            ctx.toastMessages('error', '', t("SelectedLine"))
            return
        }
        ctx.passValue.set('lines', data)
        if (operation === 'edit') {
            ctx2.newTab('createGenerator', t("EditGenerator"))
            return
        }
    }

    const deleteGenerator = (data) => {
        const tempData = data
        ctx.passValue.set('lines', tempData)
        if (!tempData) {
            ctx.toastMessages('error', t("SelectedLine"), '')
            return
        }
        if (Array.isArray(tempData)) {
            ctx.passValue.delete('lines')
            tempData.forEach(obj => {
                deleteFunc(obj.Id)
            })
            return
        }
        deleteFunc(tempData.Id)
    }

    function deleteFunc(id) {
        bufferServiceGenerator.delete(id).then(ResData => {
            if (ResData.name === 'AxiosError') {
                ctx.toastMessages('error', '', t("ErrorDeleteGenerator"))
                return
            }
            ctx.toastMessages('success', '', t("SuccessDeleteGenerator"))
            setRefresh(true)
        })
    }

    const removeContextItems = ['View', 'Copy']

    return (
        <div className='backgroundForms'>
            < div >
                <div>
                    <M_Table
                        roleName={'Generator'}
                        filtersOnTable
                        entityName={'Generator'}
                        removeContextItems={removeContextItems}
                        refresh={refresh}
                        setRefresh={setRefresh}
                        rolePermissions={roles}
                        replaceFunctions={new Map([
                            ['Delete', (data) => deleteGenerator(data)],
                            ['Create', (data) => NewRoute('', '', 'create', data)],
                            ['Edit', (data) => NewRoute('', '', 'edit', data)]
                        ])}
                    />
                </div>
                <div className='dividerTables'></div>
            </div>
        </div >
    )

}